module.exports = __webpack_public_path__ + "img/img-register-success.69d257ac.png";